module.exports = __webpack_public_path__ + "static/media/contract-address.abb6884b.webp";